import ConfirmationBox from "./ConfirmationBox";

export default ConfirmationBox;



// WEBPACK FOOTER //
// ./src/commonComponents/ConfirmationBox/index.js